module.exports = __webpack_public_path__ + "static/media/trollFace.8cc7beff.png";